/**
 * What PostHog in the browser and the static host's arm picker read off a
 * visit the same way: the campaign the page's address carries, and whether
 * the visitor turned analytics off.
 *
 * Plain JS with no imports so both sides can read it: `server/experimentArms.mjs`
 * runs unbundled under node, and `src/tracking/posthog.ts` is bundled by Vite.
 */

/** The address's campaign parameters, registered on every event as PostHog names them. */
export const CAMPAIGN_PARAMS = [
  "utm_medium",
  "utm_source",
  "utm_campaign",
  "utm_content",
  "gclid",
  "fbclid",
  "msclkid",
];

/**
 * Whether CookieYes' consent cookie holds a refusal of analytics. Analytics is
 * on until the visitor refuses: the cookie an untouched banner writes
 * (`action:` still empty) holds the region's defaults, not a choice.
 *
 * @param {string | undefined} consent the `cookieyes-consent` cookie's value
 */
export function refusesAnalytics(consent) {
  const choice = (consent ?? "").split(",");
  return choice.includes("action:yes") && choice.includes("analytics:no");
}
